import React from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';
import util from '../../../../util';
import { useMediaQuery } from 'react-responsive';

const ViewRenderer = (props) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
};

export default ViewRenderer;
